export default {
  //Lithuania  lt(languagecode) LT(countrycode)  Lietuva / Lietuvių 
  LandingPage: {
    intro_sub:
      'Suteikite antrą gyvenimą pakuotėms ir saugokite aplinką.',
    title: 'Samsung Upcycle-Packagings',
    sequence1_1: 'Prisijunkite prie mūsų, sumažinkite atliekų kiekį',
    sequence1_2:
      'Skirta tvariai aplinkai: perkurkite produktas pakuotę į naudingus daiktus. Pažiūrėkite žemiau, kad galėtumėte pradėti.',
    sequence2_1: 'Pristatome „Samsung Upcycle-Packaging',
    sequence2_2:
      'Produktas dėžutė, specialiai sukurta perdarymui, kad prisidėtumėte prie aplinkos apsaugos. Pasigaminkite įvairių namų apyvokos daiktų iš savo produktas įpakavimo',
    sequence3_1: 'Sekite atspausdintus taškus ant pakuotės',
    sequence3_2:
      'Iškirpkite pakuotę taip, kaip nurodyta, ir surinkite. Sukurkite nuostabų daiktą!',
    sequence4_1: 'Pasirinkite, ką norite padaryti',
    sequence4_2:
      'Pažiūrėkite žemiau ir pasirinkite produktas modelį, kurį įsigijote. Atraskite įvairių dizaino variantų. Pradėkite kurti norimą daiktą.',
    selectBox: 'Pasirinkite savo produktas',
    moreActivity:
      "Daugiau informacijos apie tvarią „Samsung“ veiklą",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'Rėmas', //update
    theSerif: 'Serifas', //update
    theSero: 'Sero', //update
    theTerrace: 'Terasa', //update
    thePremiere: 'Premjera', //update
    Monitors: 'Monitoriai', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q garsiakalbiai', //update
    Soundbar: 'Garsiakalbiai', //update
    SoundbarSet01:'Garsiakalbių rinkinys 1',
    SoundbarSet02:'Garsiakalbių rinkinys 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    // 'https://www.samsung.com/lt/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/lt/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/lt/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung Electronics Italia S.p.A - P.I. 11325690151 - Tutti i diritti riservati.`,
  },
  ProductPage: {
    selectDesign: 'Pasirinkite, ką norite padaryti',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV konsolė',
    StorageBox: 'Laikymo dėžė',
    MagazineRack: 'Žurnalų dėklas',
    CatHouse: 'Katės namelis',
    CatTunnel: 'Katės tunelis',
    BookShelf: 'Knygų lentyna',
    DeskShelf: 'Laikymo lentyna',
    BlackRhino: 'Nykstantys gyvūnai\n- juodasis raganosis', //update
    PolarBear: 'Nykstantys gyvūnai\n- baltasis lokys', //update
    SeaTurtle: 'Nykstantys gyvūnai\n- jūrinis vėžlys', //update
    TheRider: 'Raitelis', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Spintele', //update
    Twist: 'Dėžutė', //update
    AlexCouchArmTable: 'Laikiklis sofos\n ranktūriui', //update
    BlastOffClubHouse: 'Pakylantis namelis', //update
    KinokoTable: 'Kinoko stalas', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Būgnelis', //update
    PostCardPlanter: 'Atviručių\n stovas', //update
    SneakerRack: 'Spotbačių\n spintelė', //update
    TheSoban: 'Staliukas ir kėdutė', //update
    ToolBox: 'Įrankių dėžė', //update
    DeskStationary: 'Raštinės reikmenų dėžė',
    CoinBank: 'Monetų dėžutė',
    MobileScanner:'Telefono laikiklis skanavimui',
    TabletScanner:'Plančetės laikiklis skanavimui',
    PetStairs:'Naminių gyvūnėlių laiptai',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minutės',
    all:'ALL',
    in: 'į',
    inOnly: 'tik į',
    allBoxSize: 'Visi dėžių dydžiai',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Instrukcijos',
    prepare: 'Paruošk dėžę',
    LetsDesign: "Sukurk",
    drawParts: 'Pieštinės dėžės dalys',
    note1: 'Atkreipkite dėmesį, kad grafika gali skirtis priklausomai nuo šalies ir dydžių',
    note2: 'Pirmiausia nubraižykite visą piešinį taip, kad jis tilptų į dėžę',
    numberSpace: 'skaičius = tarpai tarp taškų',
    diagonal: 'įstrižai',
    LEFT: 'Kairė (dalis)',
    RIGHT: 'Dešinė (dalis)',
    TOP: 'Viršutinė (dalis)',
    TOP1: 'Viršutinė (dalis) 1',
    TOP2: 'Viršutinė (dalis) 2',
    BACK: 'Nugarėlė (dalis)',
    MIDDLE: 'Vidurinė (dalis)',
    MIDDLE2: 'Vidurinė (dalis) 2',
    BOTTOM: 'Apatinė (dalis)',
    FRONT: 'Priekinė (dalis)',
    SIDE: 'Šoninė (dalis)',
    secondSIDE: 'Antra pusė (dalis)',
    secondSIDE1: 'Antra pusė (dalis) 1',
    secondSIDE2: 'Antra pusė (dalis) 2',
    LEG: 'Koja (dalis)', //update
    JOINT: 'Sujungimas (dalis)', //update
    FACE: 'Veidas (dalis)', //update
    DRAWERBOTTOM: 'Spintelės apačia (dalis)', //update
    DRAWERSIDE: 'Spintelės šonas (dalis)', //update
    NOSE: 'Nosis (dalis)', //update
    HANDLE: 'Rankena (dalis)', //update
    BOTTOMSIDE: 'Apatinė pusė (dalis)', //update
    TOPSIDE: 'Viršutinė pusė (dalis)', //update
    WING: 'Sparnas (dalis)', //update
    cutAndAssemble: "Iškirpkite ir surinkite",
    beCareful: 'Būkite atsargūs, kad nenukentėtumėte naudodami pjaustytuvą',
    cutOutParts: 'Išpjaukite dalis',
    assemble: 'Surinkite',
    Assemblyguide: 'Surinkimo instrukcija', //update
    fold: 'Sulankstomas pavyzdys',
    foldGuide: 'Sulenkdami kartoną naudokite baldo kraštą',
    foldGuideDezeen:
      'Kelis kartus paspauskite punktyrinę liniją ant kartono, kad kartonas galėtų lengviau sulankstyti', //update
    glue: 'Ant paviršiaus tolygiai tepkite klijus ar klijuokite lipnią juostą', //update
    cable: 'Norėdami sujungti, naudokite virvutes', //update
    done: 'Padaryta!',
    goBack: 'Grįžkite į pagrindinį meniu',
  },
  CautionPage: {
    CAUTION: 'Įspėjimas',
    needItem: 'Jums reikės šių daiktų',
    children: 'Vaikai turi būti prižiūrimi suaugusiųjų',
    mat:
      'Prašau uždenkite paviršių, kad išvengtumėte subraižymų',
    doNotPutHeavyThing:
      'Nelipkite ir nesėskite ant šių baldų, nedėkite sunkių daiktų',
    doNotThrow:
      'Nemeskite ir nespirkite daiktų į nieką (nei į žmones, nei į gyvūnus)',
    stayAwayFlame: 'Saugokite nuo ugnies',
    stayAwayWater: 'Saugokite nuo vandens ir drėgmės',
    mayDamaged: '* TV dėžė gali būti pažeista siunčiant',
    companyDoestResponsible:
      '* Kompanija neprisiima jokios atsakomybės už sužeidimus ar nelaimingus atsitikimus galimus šio darbo metu',
    cannotBeReturned:
      '* Produktai su pažeistomis dėžėmis negali būi grąžinami kaip nekokybiški',
    understand: 'Taip, aš suprantu',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Žalias judėjimas',
      text1:
        'Norėdami būti tvaresni, daugumai televizijos pakuočių sunaudojome mažiau popieriaus ir rašalo, palyginus su ankstesnėmis pakuotėmis',
      text2:'',
      text2_special:
        '(* Aukščiau išvardyti dalykai netaikomi tam tikriems modeliams, įskaitant „Lifestyle“ televizorius)',
      text3: 'Pasirinkite žemiau pateiktus mygtukus, kad sužinotumėte daugiau',
    },
    greenIn: {
      title: '„Žalioji“ televizijos pakuotė',
      subtitle1: 'Ieškokite informacijos apie produktą',
      subtitle2: '„Eco-Package“ atnaujinimas',
      desc: 'Ieškokite modelio pavadinimo, kad gautumėte daugiau informacijos',
      descM: '* Nufotografuokite televizoriaus modelio numerį',
      guide: 'modelio pavadinimas',
      button: 'Nufotografuokit',
      button2: 'Eikite daryti daiktus',
      product_info: 'Produkto informacija',
    },
    search: {
      guide: 'Paieška..',
      noResult: 'Nėra rezultatų',
      more: 'Daugiau',
      search: 'Paieška',
      retake: 'Iš naujo',
      result: 'Rezultatas',
    },
    photo: {
      guide1: 'Į langelį įrašykite televizoriaus modelio pavadinimą',
      guide2: '(e.g Q800A, UT7000, RU7100, etc)',
    },
  },
  searchCountrySelect: 'Pasirinkite šalį paieškai'
};
